import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewProducts = ({ page = 1, limit = 10 } = {}) => {
    return useQuery({
        queryKey: ["viewproducts", page, limit],
        queryFn: async () => {
            const res = await api.get("/products/show", {
                params: { page, limit },
            });
            return res.data;
        },
        keepPreviousData: true,
    });
};